import { put } from 'redux-saga/effects';

import { ISubscriptionWellfunnel } from 'api/components/Subscriptions/types';

import { openModal } from 'store/modals/actions';

import { ModalName } from 'modals/types';

import { getCancelSubscriptionSuccessModalData } from 'helpers/subscriptions';

export function* callSuccessCancellingBehaviour({
    cancellationCandidates,
}: {
    cancellationCandidates: ISubscriptionWellfunnel[];
}) {
    const [firstCandidate, secondCandidate] = cancellationCandidates;

    yield put(
        openModal(ModalName.SuccessModal, {
            ...getCancelSubscriptionSuccessModalData([firstCandidate, secondCandidate]),
        })
    );
}
